<template>
  <svg
    width="1104"
    height="1058"
    viewBox="0 0 1104 1058"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_8002_12752)">
      <ellipse
        cx="120.306"
        cy="161.618"
        rx="120.306"
        ry="161.618"
        transform="matrix(-0.470206 -0.882556 -0.882556 0.470206 751.411 559.354)"
        fill="#A370F7"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_8002_12752"
        x="0.510101"
        y="0.380463"
        width="1103.39"
        height="1057.58"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="199.105"
          result="effect1_foregroundBlur_8002_12752"
        />
      </filter>
    </defs>
  </svg>
</template>
